<template>
  <div>
    <v-card v-if="activites.length > 0" class="transparent" flat>
      <v-card-text>
        <v-list two-line subheader>
          <v-list-item
            v-for="(item, index) in filtreParcoursEffectif(
              campagne.ll_campagne,
              campagne.annee
            )"
            :key="index"
            @click="gotoDetailsParcoursEffectif(item)"
            class="grey lighten-3"
          >
            <template v-if="mois == $moment(item.ll_mois).format('MMMM YYYY')">
              <v-list-item-content>
                <v-list-item-title>{{ item.ll_parcours }}</v-list-item-title>

                <v-list-item-subtitle>
                  {{ $moment(item.ll_mois).format("MMMM YYYY") }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-btn>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list>

        <!--    <template>
          <v-list>
            <v-list-item v-for="(item, index) in activites" :key="index">
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  item.ll_parcours
                }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ annee }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ mois }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ campagne.ll_campagne }}</v-list-item-subtitle>
                
              </v-list-item-content>
            </v-list-item>
          </v-list> 
        </template>-->
      </v-card-text>
    </v-card>

    <div v-else>
      Pas d'activités
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Etapes: require("@/components/organisation/etapes").default,
  },
  created() {
    this.getActiviteData(this.nomProjet);
  },
  props: {
    nomProjet: {
      required: true,
    },
    annee: {
      required: false,
    },
    mois: {
      required: false,
    },
    campagne: {
      required: false,
    },
  },
  data() {
    return {
      activites: [],
    };
  },
  computed: {
    ...mapState({
      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectif,
      Campagnes: (state) => state.Campagnes.Campagnes,
      campagneActive: (state) => state.Campagnes.campagneActive,
    }),
  },
  methods: {
    getActiviteData(nomProjet) {
      console.log("nomProjet : ", nomProjet);
      let self = this;
      this.$firebase
        .firestore()
        .collection("activites")
        .where("ll_programme", "==", nomProjet)
        .get()
        .then((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              //console.log("New Doc: ", change.doc.data());
              self.activites.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === "modified") {
              let obj = self.activites.find(
                (search) => search.id === change.doc.id
              );

              //bailleurs
              /*  obj.name = change.doc.data().abbr_bailleur;
                            obj.title = change.doc.data().ll_bailleur;
                            obj.ll_bailleur = change.doc.data().ll_bailleur;
                            obj.abbr_bailleur = change.doc.data().abbr_bailleur; */
            }
            if (change.type === "removed") {
              /*   console.log("Removed : ", change.doc.data());
                            let obj = elems.find((search) => search.id === change.doc.id);
                            const index = elems.indexOf(obj);
                            Vue.delete(elems, index); */
              //deleteProjetsDeBailleurs
            }
          });
        });
    },
    filtreParcoursEffectif(ll_parcours_effectif, annee) {
      console.log("ll_parcours_effectif :", ll_parcours_effectif);
      let self = this;
      return _.filter(this.ParcoursEffectif, {
        ll_parcours_effectif: ll_parcours_effectif,
      });
      //return this.ParcoursEffectif;
    },
    gotoDetailsParcoursEffectif(item) {
      this.$router.push({
        path: `/groupes/detailsParcoursEffectif/${item.id}`,
        //query: { projet: this.$route.params.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
